<template>
    <div class="customl-section">
        <div class="customl-section-header">
            <h3>
                <i class="bx bx-wallet mr-2"></i>
                {{ getTranslations('expression_152') }}
            </h3>

            <div class="customl-wallet-header-actions">
                <div class="customl-wallet-count" v-if="wallets.pagination.total > 0">
                    <small>{{ wallets.pagination.total > 1
                        ? `${wallets.pagination.total} ${getTranslations('expression_116')}`
                        : `${wallets.pagination.total} ${getTranslations('expression_117')}` }}
                    </small>
                </div>

                <div v-if="me.data.role_key > 0"
     class="customl-add-wallet-btn"
     @click="showWalletModal = true"
     v-b-tooltip.bottom :title="getTranslations('expression_197')">
  <i class="bx bx-plus"></i>
  <span class="customl-add-wallet-text">{{ getTranslations('expression_197') }}</span>
</div>

            </div>
        </div>

        <div class="customl-wallet-content">
            <div v-if="!isLoadingWallets && wallets.pagination.total > 0" class="customl-wallet-table-wrapper">

                <table class="customl-wallet-table">
                    <thead>
                        <tr>
                            <th v-if="me.data.id === 1" class="customl-wallet-id-col">
                                {{ getTranslations('expression_28').toUpperCase() }}
                            </th>
                            <th>{{ getTranslations('expression_4') }}</th>
                            <th>{{ getTranslations('expression_12') }}</th>
                            <th>{{ getTranslations('expression_48') }}</th>
                            <th v-if="me.data.role_key > 0" class="customl-wallet-actions-col">
                                {{ getTranslations('expression_198') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="wallet in wallets.pagination.data" :key="wallet.id" class="customl-wallet-row">
                            <td v-if="me.data.id === 1" class="customl-wallet-id">
                                <span class="customl-wallet-id-badge" v-b-tooltip.bottom :title="wallet.id">
                                    #{{ wallet.id }}
                                </span>
                            </td>
                            <td class="customl-wallet-channel">
                                <div class="customl-wallet-cell-content" v-b-tooltip.bottom
                                    :title="getChannelObject('id', wallet.channel_id).name">
                                    {{ getChannelObject('id', wallet.channel_id).name }}
                                </div>
                            </td>
                            <td class="customl-wallet-team">
                                <div class="customl-wallet-cell-content" v-b-tooltip.bottom
                                    :title="getDepartmentObject('id', wallet.department_id).name">
                                    {{ getDepartmentObject('id', wallet.department_id).name }}
                                </div>
                            </td>
                            <td class="customl-wallet-agent">
                                <span  class="customl-wallet-cell-content" v-b-tooltip.bottom :title="getUserObject('id', getOperatorObject('id', wallet.main_operator_id).user_id).name ? getUserObject('id', getOperatorObject('id', wallet.main_operator_id).user_id).name : '---'">
                      {{ getUserObject('id', getOperatorObject('id', wallet.main_operator_id).user_id).name ? getUserObject('id', getOperatorObject('id', wallet.main_operator_id).user_id).name : '---' }}
                    </span>
                            </td>
                            <td v-if="me.data.role_key > 0" class="customl-wallet-actions">
                                <button class="customl-wallet-action-btn customl-transfer-btn"
                                @click="openTransferModal(wallet)"
                                v-b-tooltip.bottom
                                    :title="getTranslations('expression_199')">
                                    <i class="bx bx-transfer-alt"></i>
                                </button>
                                <button class="customl-wallet-action-btn customl-delete-btn"
                                    @click.prevent="alertDeleteWallet(wallet)" v-b-tooltip.bottom
                                    :title="getTranslations('expression_200')">
                                    <i class="bx bx-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div  v-else-if="!isLoadingWallets" class="customl-no-data">
                <i class="bx bx-inbox"></i>
                <span>{{ getTranslations('expression_201') }}</span>
            </div>

            <!-- Pagination -->
            <div v-if="wallets.pagination.total > 0" class="customl-wallet-pagination">
                <Pagination class="customl-pagination"
                    page_item="background-color: #ffffff!important; border-color: #ffffff!important;"
                    page_link="background-color: #ffffff!important; border-color: #ffffff!important;"
                    :items="wallets.pagination" commit="SET_WALLETS">
                </Pagination>
            </div>
        </div>
        <ModalWallet
  v-if="showWalletModal"
  :visible="showWalletModal"
  :lead="lead"
  @close="showWalletModal = false"
/>
<ModalTransferWallet
  v-if="showTransferModal"
  :visible="showTransferModal"
  @close="showTransferModal = false"
  @transferred="onTransferCompleted"
/>


    </div>
    
</template>

<script>
import Pagination from "../../components/theme/Pagination.vue";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import ModalWallet from "../../components/modals/CreateWalletModal.vue";
import ModalTransferWallet from "../../components/modals/ModalTransferWallet.vue";

export default {
    name: "WalletSection",
    components: {
        Pagination,
        ModalWallet,
        ModalTransferWallet 
    },
    props: {
        lead: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showTransferModal: false,
            showWalletModal: false,
            isLoadingWallets: false,
            add_wallet: {
                main_operator_id: null,
                department_id: null
            },
        }
    },
    watch: {
  'lead.id'(newId) {
    if (newId) {
      this.$store.dispatch('getWallets', { lead_id: newId });
    }
  }
},
mounted() {
  if (this.lead?.id) {
    this.$store.dispatch('getWallets', { lead_id: this.lead.id });
  }
},
    computed: {
        ...mapState(['wallets', 'me']),
        ...mapGetters([
            'getChannelObject',
            'getDepartmentObject',
            'getUserObject',
            'getOperatorObject',
            'getTranslations',
          
        ]),
    },
    methods: {
//        showWallet(wallet) {
//   $('#transferWalletModal').modal('show');
//   const cloned = this.xeroxHelper(wallet);
//   cloned.main_operator_id = null;
//   this.$store.dispatch('getWallet', cloned);
// },
openTransferModal(wallet) {
    this.$store.commit('SET_WALLET', wallet) 
    this.showTransferModal = true;
  },
        alertDeleteWallet(payload) {
            this.$swal.fire({
                title: this.getTranslations('expression_887'),
                text: this.getTranslations('expression_890'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.getTranslations('expression_421'),
                cancelButtonText: this.getTranslations('expression_355')
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteWallet(payload)
                }
            })
        },
        deleteWallet(payload) {
        payload.data = {
            lead_id: this.lead.id
        };
        this.isLoadingWallets = true;
        this.$store.dispatch('deleteWallet', payload).then(() => {
            this.$store.dispatch('getWallets', {
                lead_id: this.lead.id
            }).finally(() => {
                this.isLoadingWallets = false;
            });
        });
    },
 onTransferCompleted() {
  this.showTransferModal = false;
  this.isLoadingWallets = true;
  
  // Aguardar um momento antes de recarregar para garantir que a transferência foi processada
  setTimeout(() => {
    this.$store.dispatch('getWallets', {
      lead_id: this.lead.id
    }).finally(() => {
      this.isLoadingWallets = false;
    });
  }, 300); // Aumentei o tempo para 300ms
},

//   openTransferModal(wallet) {
//     this.$store.commit('SET_WALLET', wallet);
//     this.showTransferModal = true;
//   },
    }
}
</script>

<style scoped>
.customl-section {
    margin-bottom: 24px;
}

.customl-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.customl-section-header h3 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
    display: flex;
    align-items: center;
}

.customl-section-header h3 i {
    color: #13c2c2;
    font-size: 18px;
}

.customl-wallet-header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.customl-wallet-count {
    font-size: 13px;
    color: #666;
    background-color: #f5f5f5;
    padding: 4px 10px;
    border-radius: 12px;
}

.customl-add-wallet-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: #f9f9f9;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.customl-add-wallet-btn:hover {
    background-color: #f0f0f0;
    border-color: #d9d9d9;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.customl-add-wallet-btn i {
    font-size: 16px;
    color: #13c2c2;
}

/* Wallet content */
.customl-wallet-content {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    border: 1px solid #eaeaea;
}

/* Table styles */
.customl-wallet-table-wrapper {
    overflow-x: auto;
    width: 100%;
}

.customl-wallet-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.customl-wallet-table th {
    background-color: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid #eaeaea;
    white-space: nowrap;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.customl-wallet-table td {
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
}

.customl-wallet-row {
    transition: background-color 0.2s ease;
}

.customl-wallet-row:hover {
    background-color: #f0f9fa;
}

.customl-wallet-row:last-child td {
    border-bottom: none;
}

/* Cell content */
.customl-wallet-cell-content {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* ID column */
.customl-wallet-id-col {
    width: 60px;
}

.customl-wallet-id {
    text-align: center;
}

.customl-wallet-id-badge {
    background-color: #f0f9fa;
    color: #13c2c2;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

/* Actions column */
.customl-wallet-actions-col {
    width: 100px;
    text-align: center;
}

.customl-wallet-actions {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.customl-wallet-action-btn {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    cursor: pointer;
    transition: all 0.2s ease;
}

.customl-transfer-btn:hover {
    background-color: #e6f7ff;
    color: #1890ff;
}

.customl-delete-btn:hover {
    background-color: #fff1f0;
    color: #ff4d4f;
}

/* No data message */
.customl-no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 30px 20px;
    color: #888;
    text-align: center;
}

.customl-no-data i {
    font-size: 32px;
    color: #d9d9d9;
}

/* Pagination */
.customl-wallet-pagination {
    padding: 12px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: center;
}

.customl-pagination {
    margin-bottom: 0 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {

    .customl-wallet-table th,
    .customl-wallet-table td {
        padding: 10px 12px;
    }

    .customl-wallet-cell-content {
        max-width: 150px;
    }

    .customl-add-wallet-text {
        display: none;
    }

    .customl-add-wallet-btn {
        padding: 6px;
    }
}

@media (max-width: 576px) {
    .customl-section-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .customl-wallet-header-actions {
        width: 100%;
        justify-content: space-between;
    }

    .customl-wallet-count {
        align-self: flex-start;
    }

    .customl-wallet-table {
        font-size: 13px;
    }

    .customl-wallet-table th {
        font-size: 11px;
    }

    .customl-wallet-cell-content {
        max-width: 120px;
    }

    .customl-wallet-action-btn {
        width: 28px;
        height: 28px;
    }
}
</style>